import * as React from 'react';
import { Stack, Grid, Typography, Box, Divider, useMediaQuery, useTheme } from '@mui/material';
import Logo from '../../components/ui/Logo';
import { Link } from 'react-router-dom';
import AuthCardWrapper from './AuthCardWrapper';
import { primary } from 'lib/mui/colors';
import PublicLayout from './PublicLayout';

export default function Login(): JSX.Element {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <PublicLayout>
            <Grid
                item
                xs={12}
                container
                justifyContent="center"
                alignItems="center"
                sx={{ minHeight: { xs: 'calc(100vh - 68px)', md: 'calc(100vh - 152px)' } }}
            >
                <Stack justifyContent="center" alignItems="center" spacing={5} m={2}>
                    <Box component={Link} to="#" sx={{ display: { xs: 'block', md: 'none' } }}>
                        <Logo />
                    </Box>
                    <AuthCardWrapper border={matchDownMD}>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item>
                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                    <Typography color={primary[700]} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                                        404 Not Found
                                    </Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item>
                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                    <Typography color={primary[700]} gutterBottom variant="h4">
                                        The page you are looking for does not exist
                                    </Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                    </AuthCardWrapper>
                </Stack>
            </Grid>
        </PublicLayout>
    );
}
